import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { FIELDS } from "lib"
import { AUXILIAR_PATH, REPORT_PATH, UPLOAD_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadAuxiliar = async (file: any) => {
  const formData = new FormData()
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      REPORT_PATH + AUXILIAR_PATH + UPLOAD_PATH,
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const uploadAuxiliarNUEVO = async (file: any) => {
  const formData = new FormData()
  formData.append(FIELDS.file.key, file)
  try {
    const result = await instance.post(
      REPORT_PATH + AUXILIAR_PATH + UPLOAD_PATH + "/new",
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
